export const BULK_ACTION_PROVIDER_KEY = 'bulkActionProvider'
